import { render, staticRenderFns } from "./UserAgreementView.vue?vue&type=template&id=ecefd7c0&scoped=true&style=background-color%3A%20transparent%3B%20position%3Arelative%3B"
import script from "./UserAgreementView.vue?vue&type=script&lang=js"
export * from "./UserAgreementView.vue?vue&type=script&lang=js"
import style0 from "./UserAgreementView.vue?vue&type=style&index=0&id=ecefd7c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecefd7c0",
  null
  
)

export default component.exports